export default "/assets/images/pm-png.4f15805e46019ec7.png";